<template>
    <v-container fluid class="conteudoVideo">
        <v-row no-gutters>
            <v-col cols="12" class="text-center">
                    <vue-plyr style="width: 100%; margin: 0 auto;" :options="optPlayer" quality ref="plyr" :emit="['timeupdate','ended']" @timeupdate="timeupdated($event)" @ended="endered($event)">
                        <div class="plyr__video-embed" ref="frame" style="background-color: blue;">
                            <iframe :src="aula.url_video" allowfullscreen allowtransparency allow="autoplay"></iframe>
                        </div>
                    </vue-plyr>
                
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import axios from 'axios'
import {mapState} from 'vuex'
import { baseApiUrl, showError, showSuccess } from "@/config/global"

export default {
    props: ['aula'],
    computed:{
        ...mapState(['user']),
    },
    data(){
        return{
            optPlayer: {
                controls: [
                    'play',
                    'progress',
                    'mute',
                    'volume',
                    'settings',
                    'fullscreen',
                    'quality'
                ],
                settings: [
                        'quality', 'speed', 'loop'
                    ],
            }
        }
    },
    methods:{

        async alterarConclusao(){

            const url = `${baseApiUrl}/estudos/Cursos/alterarConclusaoAula.php`    
                let params = {
                    concluir: this.aula.concluida ? true : false,
                    idAula: this.aula.id,
                    idIniciado: this.user.iniciado
                }
                await axios.post(url, params).then(res => {
                    if(res.data.codigo == '01'){
                        showSuccess(res.data.mensagem)
                        if(this.aula.concluida){
                            this.$emit('aumentaAulasCompletas')
                        }else{
                            this.$emit('diminuiAulasCompletas')
                        }
                    }else if(res.data.codigo != '05'){
                        showError(res.data.mensagem)
                    }
                })
        },


        timeupdated(ev){
            if(!this.ativar && (ev.detail.plyr.duration - ev.detail.plyr.currentTime) < 10){
                this.ativar = true
                this.aula.concluida = true
                this.alterarConclusao()
            }
        },

        endered(ev){
            this.$emit('aulaFinalizada', ev)
        },

        
    }
}
</script>

<style scoped>

.fundoVideo{
    background-color: black;
    width: 100%;
    height: 70vh;
}
</style>